import { c as _c } from "react/compiler-runtime";
import { parseAsArrayOf, parseAsString, parseAsStringEnum, useQueryState } from 'nuqs';
import { useCallback } from 'react';
import { WorkstreamStatus } from '@/modules/__generated__/graphql/switchboard-generated';
function useWorkstreamFilters() {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsString.withDefault("").withOptions({
      shallow: false,
      history: "replace",
      limitUrlUpdates: {
        method: "debounce",
        timeMs: 300
      }
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [search, setSearch] = useQueryState("search", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = parseAsArrayOf(parseAsStringEnum(Object.values(WorkstreamStatus))).withDefault([]).withOptions({
      shallow: false,
      history: "replace",
      limitUrlUpdates: {
        method: "debounce",
        timeMs: 100
      }
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [statuses, setStatuses] = useQueryState("statuses", t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = parseAsArrayOf(parseAsString).withDefault([]).withOptions({
      shallow: false,
      history: "replace",
      limitUrlUpdates: {
        method: "debounce",
        timeMs: 100
      }
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [networks, setNetworks] = useQueryState("networks", t2);
  let t3;
  if ($[3] !== setNetworks || $[4] !== setSearch || $[5] !== setStatuses) {
    t3 = () => {
      setSearch("");
      setStatuses([]);
      setNetworks([]);
    };
    $[3] = setNetworks;
    $[4] = setSearch;
    $[5] = setStatuses;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onReset = t3;
  let t4;
  if ($[7] !== networks || $[8] !== onReset || $[9] !== search || $[10] !== setNetworks || $[11] !== setSearch || $[12] !== setStatuses || $[13] !== statuses) {
    t4 = {
      search,
      statuses,
      networks,
      setSearch,
      setStatuses,
      setNetworks,
      onReset
    };
    $[7] = networks;
    $[8] = onReset;
    $[9] = search;
    $[10] = setNetworks;
    $[11] = setSearch;
    $[12] = setStatuses;
    $[13] = statuses;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}
export { useWorkstreamFilters };